import CustomIconGardener from 'scoreboard/components/custom-icon-gardener'
import _ from 'lodash'
import iconForObject from 'scoreboard/components/icon-for-object'
import newFolderAddType from 'scoreboard/components/new-folder-add-type'

export default CustomIconGardener.extend({

	_url: _.constant('api/bookmarks'),

	getIcon(node) {
		return iconForObject(node, 'bookmark')
	},

	getAddType: newFolderAddType

})
